import Controller from "csi/action/Controller";
import CanvasWidget from "csi/datasheet/CanvasWidget";
import FullScreenHeader from "csi/page/FullScreenHeader";
import { browserStore, routerStore } from "csi/state/rootStore";
import declare from "dojo/_base/declare";

const FullScreenController = declare(Controller, {
	/**
	 * @override
	 * Enable full screen mode
	 */
	postProcessSuccess() {
		const view = this.widget as CanvasWidget;

		browserStore.enterFullScreen(view.compositeCustomViewName);

		new FullScreenHeader({
			title: routerStore.locationTitle,
			icon: "csiActionIcon iconZoomInMap",
			view,
		}).placeAt("pageHeader", "before")
			.startup();

		// update svg toolbar if it exists
		view.canvasWidgetNode?.updateToolbar();
	},
});

export = FullScreenController;
